/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Carrier_Legacy_Caption_DefaultInputs */

const vi_carrier_legacy_caption_default = /** @type {(inputs: Carrier_Legacy_Caption_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chọn nơi khách ở; không rõ thì bấm "Đúng xã này"`)
};

/**

* @param {Carrier_Legacy_Caption_DefaultInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const carrier_legacy_caption_default = /** @type {((inputs?: Carrier_Legacy_Caption_DefaultInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_Legacy_Caption_DefaultInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_carrier_legacy_caption_default(inputs)
});